"use client";

import { useCallback } from "react";
import { useAdvancedAlgoliaSearch } from "@/lib/hooks/algolia-search";
import type { SearchResult } from "@/lib/hooks/algolia-search/types";

/**
 * Record search for the command palette.
 *
 * Deliberately thin: it reuses the SAME search layer as the full-page search
 * (`/api/search/{contacts,companies,deals,tasks,emails}` fanned out by
 * `useAdvancedAlgoliaSearch`) so the palette and `/search` can never disagree
 * about what exists or who may see it.
 */
export function useCommandPaletteSearch(): (query: string) => Promise<SearchResult[]> {
  const { searchAlgolia } = useAdvancedAlgoliaSearch();

  return useCallback(
    async (query: string) => {
      const results = await searchAlgolia(query);
      return results ?? [];
    },
    [searchAlgolia]
  );
}
